var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnguilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccc32",
    d: "M25.97 7.23s-.96.34-2.05.34-1.9-.57-1.9-.57-.8.57-1.89.57-2.1-.34-2.1-.34c-.1 2.74.06 5.63 1.06 7.14A9 9 0 0 0 22.03 17s1.81-1 2.88-2.63c1-1.51 1.17-4.4 1.06-7.14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.63 7.55s-.77.3-1.8.3-1.8-.52-1.8-.52-.77.52-1.8.52-1.8-.3-1.8-.3c-.1 2.6 0 5.26 1 6.66.99 1.4 2.6 2.37 2.6 2.37s1.6-.97 2.6-2.37 1.1-4.06 1-6.66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M21.13 7.94s.03.46.22.62c0 0 .48-.1.87.06.3.13.87.36 1.16.26s.54-.19.6-.13c.07.07-.32.17-.38.23-.07.07-.29.13-.16.33s.35.35.29.55c0 0-.29-.23-.42-.42-.13-.2-.42-.36-.9-.3-.48.07-.87.33-.93.62-.07.3.29.26.58.33 0 0-.42.16-.64.16 0 0-.2.36-.4.68-.18.33-.22.52-.31.49-.1-.04-.13-.49-.07-.75 0 0-.22-.13-.19-.78.03-.55.42-1.07.42-1.07s-.03-.2 0-.42c.03-.23.26-.46.26-.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.77 10.23-.03.08-.08.04a.1.1 0 0 1-.11-.12.11.11 0 0 1 .19-.08q.03.03.03.08"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M20.1 13.49s.33-.31.33-.57c0 0-.38-.31-.5-.72-.1-.32-.27-.9-.53-1.07-.26-.16-.5-.3-.49-.4.01-.08.33.16.42.16.1.01.29.15.35-.07.07-.23.05-.5.24-.58 0 0 .01.37-.06.6s0 .55.35.88c.35.34.8.48 1.06.34.27-.13.02-.39-.12-.66 0 0 .4.23.54.4l.76-.12c.37-.06.54-.16.58-.06s-.3.4-.54.52c0 0 .05.26-.47.65-.44.33-1.09.35-1.09.35s-.12.14-.32.26-.51.09-.51.09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.08 12.32.08-.02a.1.1 0 0 1 .1.12q0 .05-.04.07a.1.1 0 0 1-.1.02.11.11 0 0 1-.04-.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M25.21 11.56s-.42-.17-.65-.07c0 0-.12.48-.43.76-.25.23-.7.64-.74.94s-.07.58-.15.61c-.09.03 0-.36-.04-.45-.03-.08.02-.32-.21-.29s-.48.17-.62.03c0 0 .33-.17.56-.2s.5-.22.65-.69.1-.93-.14-1.11c-.23-.2-.36.14-.54.38 0 0 .04-.45.13-.66l-.43-.65c-.2-.31-.37-.43-.3-.5s.5.1.7.27c0 0 .21-.15.78.16.48.27.77.85.77.85s.18.06.37.19a1 1 0 0 1 .3.43"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.33 10.24a.11.11 0 0 1 .01-.21.1.1 0 0 1 .14.07v.08a.1.1 0 0 1-.15.06"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m19.27 13.98.15.23c1 1.4 2.6 2.37 2.6 2.37s1.62-.97 2.61-2.37l.15-.23z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnguilla);
export default __webpack_public_path__ + "static/media/anguilla.c369b817f5ce3be913d548f217599df0.svg";
export { ForwardRef as ReactComponent };